import { useState, useMemo, useCallback } from "react";
import {
    useLocalPreferences,
    useLocalPreferencesLoader,
} from "../../../hooks/useLocalPreferences";
import useInitial from "./useInitial";
import { SPORTS, SPORTS_PREFERENCES } from "../constants";
import { OLYMPICS_FILTER_NS as NAMESPACE } from "../../../actions/DMP/constants";
export const getSport = (id) => {
    return SPORTS[id];
};

export const computeDelta = (lastPrefs, nextPrefs) => {
    let delta = {};
    for (let key of Object.keys(nextPrefs)) {
        if (!!lastPrefs[key] !== !!nextPrefs[key]) {
            delta[key] = nextPrefs[key];
        }
    }
    return delta;
};

export const usePreferences = () => {
    const [preferences, setPreferences] = useState({});
    useLocalPreferencesLoader(NAMESPACE, SPORTS_PREFERENCES);
    const { preferences: lastSavedPreferences, update } =
        useLocalPreferences(NAMESPACE);

    const initial = useInitial();

    const hasChanges = useMemo(() => {
        let last;
        if (
            lastSavedPreferences &&
            Object.values(lastSavedPreferences).length
        ) {
            last = lastSavedPreferences;
        } else if (initial.isLoaded) {
            last = initial.preferences;
        } else {
            return false;
        }
        return !!Object.values({
            ...last,
            ...preferences,
        }).filter((value) => value).length;
    }, [
        preferences,
        lastSavedPreferences,
        initial.preferences,
        initial.isLoaded,
    ]);

    const save = useCallback(() => {
        const delta = computeDelta(lastSavedPreferences, preferences);
        update(delta);
    }, [lastSavedPreferences, preferences, update]);

    const getPreference = (sportId) => {
        const current = preferences[sportId];
        if (current !== undefined) {
            return current;
        }
        const lastSaved = lastSavedPreferences?.[sportId];
        if (lastSaved !== undefined) {
            return lastSaved;
        } else {
            return initial.preferences?.[sportId] || false;
        }
    };

    return {
        getPreference,
        hasChanges,
        update: (sport, preference) => {
            setPreferences({ ...preferences, [sport]: preference });
        },
        save,
    };
};
